module.exports = __webpack_public_path__ + "img/gjkjx.546e9ed8.jpg";